/**
 * Used to calculate prices of tickets when they might change depending on
 */
class PricingRuleCalculator {
    /**
     * @param {ApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * For an array of tickets and sessions, it fetches a price from the API that may be adjusted by pricing rules
     * relating to the session/ticket combination.
     *
     * @param {{itemID: number, sessionID:number}[]} lines
     */
    fetchSessionPricesForTickets(lines) {
        return this.apiClient
            .request(
                'POST',
                'tickets/sessionprices',
                {
                    // Map the provided lines property so we don't send extraneous stuff to the API.
                    lines: lines.map(({ itemID, sessionID }) => {
                        return {
                            itemID,
                            sessionID,
                        };
                    }),
                }
            )
            .then((response) => {
                return response.data;
            });
    }
}

module.exports = PricingRuleCalculator;
